import { render, staticRenderFns } from "./TenantUserDeleteScreen.vue?vue&type=template&id=514935f2&scoped=true&lang=pug"
import script from "./TenantUserDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./TenantUserDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./TenantUserDeleteScreen.vue?vue&type=style&index=0&id=514935f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514935f2",
  null
  
)

export default component.exports